<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { auto_resolve_pending_campaign_when_out_of_office } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!auto_resolve_pending_campaign_when_out_of_office;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_CAMPAIGN.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_CAMPAIGN.API.ERROR'));
  }
};

const toggleAutoResolveCampaign = async () => {
  return updateAccountSettings({
    auto_resolve_pending_campaign_when_out_of_office: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_CAMPAIGN.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_CAMPAIGN.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleAutoResolveCampaign" />
      </div>
    </template>
  </SectionLayout>
</template>
